export default class DropDown {

	constructor(name, element) {
		this.name = name;
		this.master = element;

		this.params = {
			activeClass: 'js-active',
			slideSpeed: this.master.getAttribute('data-speed') || 200,
			clickOut: this.master.getAttribute('data-clickOut') || false,
			targetValue: this.master.getAttribute('data-target') || this.master.getAttribute('href'),
			lock: this.master.getAttribute('data-lock') || false,
		};

		this.initElements();
	}

	get componentName() {
		return 'DropDown';
	}

	initElements() {
		this.target = this.master.querySelector(`[data-${this.componentName}-component="target"]`);
		this.closeArr = document.querySelectorAll(`[data-${this.componentName}-close]`);
	}

	start() {
		if (this.params.clickOut) {
			document.addEventListener('click', (e) => {
				const $targetValue = $(this.params.targetValue);

				if (!$targetValue.is(e.target) && $targetValue.has(e.target).length === 0) {
					$targetValue.slideUp(this.params.slideSpeed);
				}

			});
		}

		this.bindMainEvents();
		this.bindCloseEvents();

		return false;
	}

	bindMainEvents() {
		this.master.addEventListener('click', (e) => {

			this.master.classList.toggle(this.params.activeClass);

			if (this.params.lock) {
				document.body.classList.toggle('js-lock');
			}
			if ($(this.target).length) {
				$(this.target).stop().slideToggle(this.params.slideSpeed);
			} else if (this.params.targetValue) {
				$(this.params.targetValue).stop().slideToggle(this.params.slideSpeed);
			}
			e.stopPropagation();
			e.preventDefault();
		});
	}

	bindCloseEvents() {
		for (let i = 0; i < this.closeArr.length; i++) {
			let attr = this.closeArr[i].getAttribute(`data-${this.componentName}-close`) || false;
			if (!attr) {
				return false;
			}
			this.closeArr[i].addEventListener('click', () => {
				$(attr).slideUp(this.params.slideSpeed);
				document.body.classList.remove('js-lock');
			});
		}
	}
}